module.exports = __webpack_public_path__ + "images/rocket.5a5f436de3f2cb112bef.png";